import {onFind} from "./elements-packages/init-modules-in-scope";
import {on} from "@elements/dom-utils";
import {setServicePermission,getServicePermission} from "@elements/cookie-permissions";

const selectors = {
    btn: '.js-accept-cookie-service'
};

export function init () {
    onFind(selectors.btn, function (baseElement) {
        let cookieService = baseElement.dataset.cookieServiceOverlayName || false;

        if(cookieService) {
            if (getServicePermission(cookieService)) {
                console.log("get service permission");
                baseElement.setAttribute('hidden', true);
            }
            on('click', function() {
                setServicePermission(cookieService, true);
                baseElement.setAttribute('hidden', true);
            }, baseElement);
        } else {
            console.warn('cookie-service-overlay: no cookie service name found!')
        }
    });
}
